import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $ErrorsModuleName } from "./errors.types";

const getErrors = (state: IState) =>
    getValueState(state, $ErrorsModuleName)?.alerts;

export { getErrors };
